import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { Edit, Filter } from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../core/pagination/datatable";
import Axios from "axios";
import { setinventoryproducts_data } from "../../core/redux/action";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  API_BASE_URL,
  GET_USER_STORES,
  IMAGE_URL_IBIZ,
  GET_BARCODE_TYPE,
} from "../../Config";
import * as XLSX from "xlsx";
import Select from "react-select";
import SpinLoader from "../loader/SpinLoader";
import JsBarcode from "jsbarcode";
// import EditUnitInventory from "./EditUnitInventory";

const UnitInventory = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, [navigate]);

  const dispatch = useDispatch();
  const dataSource = useSelector((state) => state.inventoryproducts_data) || [];
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false); // For modal image loader
  //   const [editUnitData, setEditUnitData] = useState(null);
  const [storesData, setStoresData] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null); // Will auto-set first store

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => setIsFilterVisible((prev) => !prev);

  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const [isBarcodeModalOpen, setIsBarcodeModalOpen] = useState(false);
  const [selectedBarcodeItem, setSelectedBarcodeItem] = useState(null);
  const [barcodeSvgHtml, setBarcodeSvgHtml] = useState("");
  const [barcodeTemplateHtml, setBarcodeTemplateHtml] = useState("");

  useEffect(() => {
    if (userDataSession?.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_BARCODE_TYPE}?OrgId=${userDataSession.OrgId}`,
      )
        .then((res) => {
          if (res.data.Status && res.data.ResultData?.length > 0) {
            setBarcodeTemplateHtml(res.data.ResultData[0].HtmlString || "");
          }
        })
        .catch((err) => {
          console.error("Failed to load barcode template", err);
        });
    }
  }, [userDataSession?.OrgId]);

  const handleShowBarcode = (record) => {
    setSelectedBarcodeItem(record);
    setIsBarcodeModalOpen(true);

    // Generate barcode SVG
    const tempSvg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg",
    );
    document.body.appendChild(tempSvg);

    const barcodeValue = record.UnitBarcode || "NO-BARCODE";

    JsBarcode(tempSvg, barcodeValue, {
      format: "CODE128", // or whatever format your template expects
      lineColor: "#000",
      width: 2,
      height: 60,
      fontSize: 14,
      displayValue: true,
    });

    setTimeout(() => {
      const svgString = tempSvg.outerHTML
        .replace("<svg", '<svg width="100%" height="120"')
        .replace('style="', 'style="max-width:300px;');

      setBarcodeSvgHtml(svgString);
      document.body.removeChild(tempSvg);
    }, 100);
  };

  const handleViewImage = (record) => {
    if (!userDataSession?.OrgId || !record?.UnitId) {
      alert("Missing organization or unit ID");
      return;
    }

    const imageUrl = `${IMAGE_URL_IBIZ}ibiz/${userDataSession.OrgId}/Products/UnitInventory/${record.UnitId}.jpg`;
    setSelectedImageUrl(imageUrl);
    setImageLoading(true); // Show loader until image loads or fails
    setIsImageModalOpen(true);
  };

  // Fetch stores
  useEffect(() => {
    if (userDataSession?.UserId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?UserId=${userDataSession.UserId}`,
      )
        .then((response) => {
          if (response.data.Status && response.data.ResultData.length > 0) {
            setStoresData(response.data.ResultData);

            // Auto-select first store
            const firstStore = response.data.ResultData[0];
            const defaultOption = {
              value: firstStore.StoreId,
              label: firstStore.Name,
            };
            setSelectedStore(defaultOption);

            // Immediately fetch data for the first store
            fetchUnitInventory(firstStore.StoreId);
          } else {
            setStoresData([]);
            setSelectedStore({ value: 0, label: "No Stores" });
          }
        })
        .catch((error) => {
          console.error("Error fetching stores:", error);
        });
    }
  }, [userDataSession]);

  // Fetch Unit Inventory Data
  const fetchUnitInventory = (storeId) => {
    if (!userDataSession?.OrgId) return;

    setLoading(true);
    const payload = {
      OrgId: userDataSession.OrgId,
      ProductId: 0,
      StoreId: storeId,
    };

    Axios.post(`${API_BASE_URL}UnitInventory/getUnitProducts`, payload)
      .then((response) => {
        if (response.data.Status) {
          dispatch(setinventoryproducts_data(response.data.ResultData || []));
        } else {
          dispatch(setinventoryproducts_data([]));
          console.error("Error:", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        dispatch(setinventoryproducts_data([]));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //   const handleEditUnit = (record) => {
  //     setEditUnitData(record);
  //   }

  // Handle store change
  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
    fetchUnitInventory(selectedOption.value);
  };

  // Search filter
  const filteredData = dataSource.filter(
    (item) =>
      item.ProductName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.ProductTitle?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.UnitBarcode?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  // Export functions remain same
  const handleDownloadExcel = () => {
    if (dataSource.length === 0) return;

    const wsData = dataSource.map((item) => ({
      "Product Name": item.ProductName,
      "Product Title": item.ProductTitle,
      "Unit Barcode": item.UnitBarcode,
      "Unit Price": item.UnitPrice || "N/A",
      Status: item.Status === 1 ? "Active" : "Inactive",
      Store: item.StoreName,
      Quantity: item.Quantity,
      Weight: item.Weight || "N/A",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "UnitInventory");
    XLSX.writeFile(wb, "UnitInventory.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    const tableData = dataSource.map((item) => [
      item.ProductName,
      item.ProductTitle,
      item.UnitBarcode,
      item.UnitPrice || "N/A",
      item.Status === 1 ? "Active" : "Inactive",
    ]);

    doc.autoTable({
      head: [
        [
          "Product Name",
          "Product Title",
          "Unit Barcode",
          "Unit Price",
          "Status",
        ],
      ],
      body: tableData,
    });
    doc.save("UnitInventory.pdf");
  };

  const renderTooltip = (props) => <Tooltip {...props}>PDF</Tooltip>;
  const renderExcelTooltip = (props) => <Tooltip {...props}>Excel</Tooltip>;

  const columns = [
    {
      title: "Product Name",
      dataIndex: "ProductName",
      sorter: (a, b) => a.ProductName.localeCompare(b.ProductName),
    },
    {
      title: "Product Title",
      dataIndex: "ProductTitle",
      sorter: (a, b) => a.ProductTitle.localeCompare(b.ProductTitle),
    },
    {
      title: "Barcode",
      dataIndex: "UnitBarcode",
      sorter: (a, b) => a.UnitBarcode.localeCompare(b.UnitBarcode),
    },
    {
      title: "Price",
      dataIndex: "UnitPrice",
      render: (text) => (text ? `₹${text}` : "N/A"),
      sorter: (a, b) => (a.UnitPrice || 0) - (b.UnitPrice || 0),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text) => (
        <i
          title={text === 1 ? "Active" : "Inactive"}
          className={`fa-solid fa-circle fs-4 ${
            text === 1 ? "text-success" : "text-danger"
          }`}
        ></i>
      ),
      sorter: (a, b) => a.Status - b.Status,
    },
    {
      title: "Store",
      dataIndex: "StoreName",
      sorter: (a, b) => a.StoreName.localeCompare(b.StoreName),
    },
    {
      title: "Action",
      render: (_, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link
              to="#"
              className="btn me-2  btn-sm"
              onClick={() => handleViewImage(record)}
              title="View Image"
            >
              <i className="fa-regular fa-image fs-5"></i>
            </Link>
            <Link
              to="#"
              className="btn me-2 btn-sm"
              onClick={() => handleShowBarcode(record)}
              title="View / Print Barcode"
            >
              <i className="fa-solid fa-barcode fs-5"></i>
            </Link>
            <Link
              to="#"
              className="btn me-2  btn-sm d-none"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasEditUnitInventory"
              //   onClick={() => handleEditUnit(record)}
              title="Edit"
            >
              <Edit className="feather-edit" />
            </Link>
          </div>
        </td>
      ),
    },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2rem",
      height: "2.4rem",
    }),
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Unit Inventory</h4>
                <h6>Manage individual product units</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="pdf"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleDownloadExcel}>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="input-group search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <span className="input-group-text bg-white">
                      <i data-feather="search" className="feather-search"></i>
                    </span>
                  </div>
                </div>

                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    onClick={toggleFilterVisibility}
                  >
                    <Filter className="filter-icon" />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
              </div>

              {/* Filter Section */}
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row mb-2">
                    <div className="col-lg-4 col-sm-6 col-12">
                      <label>Store</label>
                      <Select
                        className="select"
                        value={selectedStore}
                        onChange={handleStoreChange}
                        options={storesData.map((store) => ({
                          value: store.StoreId,
                          label: store.Name,
                        }))}
                        styles={customStyles}
                        placeholder="Loading stores..."
                        isDisabled={storesData.length === 0}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="table-responsive">
                {loading ? (
                  <SpinLoader />
                ) : (
                  <Table columns={columns} dataSource={filteredData} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal with Loader */}
      <div
        className={`modal fade ${isImageModalOpen ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        onClick={() => setIsImageModalOpen(false)}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h5 className="modal-title">
                Product Image - Unit ID:{" "}
                {selectedImageUrl.split("/").pop()?.replace(".jpg", "") ||
                  "N/A"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setIsImageModalOpen(false)}
              />
            </div>
            <div className="modal-body text-center p-4">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "70vh" }}
              >
                {imageLoading && (
                  <div className="my-5">
                    <SpinLoader />
                    <p className="mt-3 text-muted">Loading image...</p>
                  </div>
                )}

                {selectedImageUrl && (
                  <img
                    src={selectedImageUrl}
                    alt="Product Unit"
                    className="img-fluid  rounded shadow"
                    style={{
                      maxHeight: "70vh",
                      objectFit: "contain",
                      display: imageLoading ? "none" : "block",
                    }}
                    onLoad={() => setImageLoading(false)}
                    onError={(e) => {
                      setImageLoading(false);

                      e.target.alt = "No Image Available";
                    }}
                  />
                )}

                <div className="mt-3 text-muted small">
                  <strong>Product:</strong>{" "}
                  {dataSource.find(
                    (item) =>
                      `${IMAGE_URL_IBIZ}ibiz/${userDataSession?.OrgId}/Products/UnitInventory/${item.UnitId}.jpg` ===
                      selectedImageUrl,
                  )?.ProductTitle || "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Barcode Modal */}
      <div
        className={`modal fade ${isBarcodeModalOpen ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        onClick={() => setIsBarcodeModalOpen(false)}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h5 className="modal-title">
                Barcode - {selectedBarcodeItem?.ProductName || "Item"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setIsBarcodeModalOpen(false)}
              />
            </div>

            {/* Barcode Modal Body - Updated */}
            <div className="modal-body text-center p-4">
              {barcodeTemplateHtml && selectedBarcodeItem && barcodeSvgHtml ? (
                <div
                  style={{
                    maxWidth: "500px",
                    margin: "0 auto",
                    border: "1px solid #ddd",
                    padding: "20px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: barcodeTemplateHtml
                      .replaceAll(
                        "#ORGNAME#",
                        userDataSession?.BusinessName || "",
                      )
                      .replaceAll(
                        "#ITEMNAME#",
                        selectedBarcodeItem?.ProductName || "",
                      )
                      .replaceAll("#WEIGHT#", selectedBarcodeItem?.Weight || "")
                      .replaceAll("#UNITS#", selectedBarcodeItem?.Unit || "")
                      .replaceAll(
                        "#MFGDATE#",
                        selectedBarcodeItem?.MfgDate || "",
                      )
                      .replaceAll(
                        "#EXPIRYDATE#",
                        selectedBarcodeItem?.ExpiryDate || "",
                      )
                      .replaceAll(
                        "#ITEMPRICE#",
                        selectedBarcodeItem?.MRP ||
                          selectedBarcodeItem?.UnitPrice ||
                          "",
                      )
                      .replaceAll("#PHNO#", userDataSession?.Phone || "")
                      .replaceAll("#BARCODEIMG#", barcodeSvgHtml),
                  }}
                />
              ) : (
                <div className="my-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading barcode...</span>
                  </div>
                  <p className="mt-3">Generating barcode...</p>
                </div>
              )}
            </div>

            <div className="modal-footer d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                onClick={() => setIsBarcodeModalOpen(false)}
              >
                Close
              </button>
              {/* Optional: Print button */}
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={() => {
                  if (!barcodeTemplateHtml || !selectedBarcodeItem) return;

                  // Fully replace ALL placeholders (same as modal)
                  let printContent = barcodeTemplateHtml
                    .replaceAll(
                      "#ORGNAME#",
                      userDataSession?.BusinessName || "Saree House",
                    )
                    .replaceAll(
                      "#ITEMNAME#",
                      selectedBarcodeItem.ProductName || "",
                    )
                    .replaceAll("#WEIGHT#", selectedBarcodeItem.Weight || "")
                    .replaceAll("#UNITS#", selectedBarcodeItem.Unit || "")
                    .replaceAll("#MFGDATE#", selectedBarcodeItem?.MfgDate || "")
                    .replaceAll(
                      "#EXPIRYDATE#",
                      selectedBarcodeItem?.ExpiryDate || "",
                    )
                    .replaceAll(
                      "#ITEMPRICE#",
                      selectedBarcodeItem?.MRP ||
                        selectedBarcodeItem?.UnitPrice ||
                        "",
                    )
                    .replaceAll("#PHNO#", userDataSession?.Phone || "")
                    .replaceAll("#BARCODEIMG#", barcodeSvgHtml);

                  // Open print window with better styling
                  const printWindow = window.open("", "_blank");
                  printWindow.document.write(`
      <html>
        <head>
          <title>Print Barcode - ${selectedBarcodeItem.ProductName || "Item"}</title>
        
        </head>
        <body>
          <div class="barcode-container">
            ${printContent}
          </div>
        </body>
      </html>
    `);

                  printWindow.document.close();

                  // Small delay to ensure content loads before printing
                  setTimeout(() => {
                    printWindow.focus();
                    printWindow.print();
                  }, 300);
                }}
              >
                <i className="fa fa-print me-2"></i>Print
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <EditUnitInventory unitData={editUnitData}/> */}
    </>
  );
};

export default UnitInventory;
